import React from "react";

export const HOME_SLOTS = [
  { value: "NONE", label: "Not placed on new home" },
  { value: "SQUARE_PRIMARY", label: "Square banners 1 (primary)" },
  { value: "SQUARE_SECONDARY", label: "Square banners 2 (secondary)" },
  { value: "SQUARE_TERTIARY", label: "Square banners 3 (tertiary)" },
  { value: "BOTTOM_BANNER", label: "Bottom banner" },
];

export const slotAllowed = (slot, imageType) => {
  if (slot === "NONE") return true;
  if (slot === "BOTTOM_BANNER") return imageType === "BANNER" || imageType === "ADS_IMAGE";
  return imageType === "SQUARE_BANNER";
};

export const slotHint = (imageType) =>
  "Square slots need the Square type; the bottom banner needs Banner type or Advertisement." +
  (imageType ? "" : " Pick an image type first.");

export const HomeSlotSelect = ({ value, imageType, onChange }) => (
  <>
    <select
      className="form-control"
      value={value || "NONE"}
      onChange={(e) => onChange(e.target.value)}
    >
      {HOME_SLOTS.map((s) => (
        <option key={s.value} value={s.value} disabled={!slotAllowed(s.value, imageType)}>
          {s.label}
        </option>
      ))}
    </select>
    <small className="text-muted">{slotHint(imageType)}</small>
  </>
);
